import GLightbox from "glightbox";
import { forAllCallback } from "kwp-core/scripts/utils/helpers";

export default function () {
    forAllCallback(".content-block.content-block--video", (el) => {
        const elId = el.getAttribute("id");
        const init = () => {
            // Create lightbox
            const lightbox = GLightbox({
                touchNavigation: true,
                loop: true,
                selector: `[data-gallery="gallery-${elId}"]`,
            });

            lightbox.elements.forEach((item, key) => {
                // Open lightbox
                item.node.addEventListener("click", (e) => {
                    lightbox.openAt(key);
                });
            });
        };

        init();
    });
}
